<p>Los facilitadores son preparados para capacitar y enseñar a otros. Adquieren todas las herramientas que proporciona nuestra escuela.</p>

